var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('p',[_vm._v("Result :"),_c('br'),(_vm.url)?_c('b',[_vm._v("Link : "+_vm._s(_vm.url))]):_vm._e()]),_c('qrcode-stream',{on:{"decode":_vm.onDecode,"init":function($event){return _vm.$emit('init', $event)}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }